import { render, staticRenderFns } from "./ProfileNewAttention.vue?vue&type=template&id=79201e06&scoped=true&"
import script from "./ProfileNewAttention.vue?vue&type=script&lang=js&"
export * from "./ProfileNewAttention.vue?vue&type=script&lang=js&"
import style0 from "./ProfileNewAttention.vue?vue&type=style&index=0&id=79201e06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79201e06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('79201e06', component.options)
    } else {
      api.reload('79201e06', component.options)
    }
    module.hot.accept("./ProfileNewAttention.vue?vue&type=template&id=79201e06&scoped=true&", function () {
      api.rerender('79201e06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/student-profile/components/new_attention/ProfileNewAttention.vue"
export default component.exports